import { render, staticRenderFns } from "./MeldRedirect.vue?vue&type=template&id=46ca88b3&"
import script from "./MeldRedirect.vue?vue&type=script&lang=js&"
export * from "./MeldRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports